import { useState, useCallback } from 'react';

export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'info', duration = 3000, options = {}) => {
    const id = Date.now();
    const newToast = { id, message, type, duration, ...options };
    
    setToasts(prev => [...prev, newToast]);

    // Auto-remove después de la duración
    setTimeout(() => {
      setToasts(prev => prev.filter(toast => toast.id !== id));
    }, duration);

    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  const success = useCallback((message, duration, options) => {
    return showToast(message, 'success', duration, options);
  }, [showToast]);

  const error = useCallback((message, duration = 10000, options) => {
    return showToast(message, 'error', duration, options);
  }, [showToast]);

  const warning = useCallback((message, duration, options) => {
    return showToast(message, 'warning', duration, options);
  }, [showToast]);

  const info = useCallback((message, duration, options) => {
    return showToast(message, 'info', duration, options);
  }, [showToast]);

  return {
    toasts,
    showToast,
    removeToast,
    success,
    error,
    warning,
    info
  };
};
